import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { BaseQueryApi } from '@reduxjs/toolkit/query'
import { PublicUserProfile, Token, TokenResponse } from '@app/services/auto-generated/auth'

// we put the actions in a seperate file to avoid circular dependencies in app/serivces/base-query

export const SET_USER = 'auth/set_user'
export const setUser = createAction<PublicUserProfile>(SET_USER)

export const SET_TOKENS = 'auth/set_tokens'
export const setTokens = createAction<TokenResponse>(SET_TOKENS)

export const SET_ACCESS_TOKEN = 'auth/set_access_token'
export const setAccessToken = createAction<Token | null>(SET_ACCESS_TOKEN)

export const LOGOUT = 'auth/logout'
export const logout = createAction<void>(LOGOUT)

export const waitForRehydration = createAsyncThunk(
  'waitForRehydration',
  async (api: BaseQueryApi) => {
    try {
      await api.dispatch({ type: 'persist/REHYDRATE' })
      return true
    } catch (error) {
      console.error('Failed to rehydrate state:', error)
      return false
    }
  },
)
